<template>
  <vs-popup class="add-new-template"
            id="popup"
            :title="isCreateMode ? 'ADD TEMPLATE' : 'UPDATE TEMPLATE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-template-popup" @submit.prevent="handleSubmit(onClickCreateTemplate)" autocomplete="off">

        <div>
    <!-- Name -->
            <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
                <vs-input
                v-model="form.name"
                label="Name"
                class="w-full"
                placeholder="Enter template name"
                />
            </div>
            </div>

            <!-- Description -->
            <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
                <vs-input
                v-model="form.description"
                label="Description"
                type="textarea"
                class="w-full"
                placeholder="Enter template description"
                />
            </div>
            </div>

            <!-- Frequency -->
            <!-- <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2 md:mb-0">
                <v-select
                name="frequencies"
                v-model="form.frequency"

                :options="frequencies"
                :reduce="option => option.value"
                class="w-full"
                >
             
                </v-select>
            </div> -->

            <!-- Allocation -->
            <!-- <div class="w-full vx-col md:w-1/2 md:mb-0">
             <v-select
              name="allocations"
             
              v-model="form.allocation"
              :options=allocations
              :reduce="option => option.value"
              placeholder="Select allocation"
            />
            </div>
            </div> -->

            <!-- Signoff Required -->
            <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
                <vs-checkbox v-model="form.signoff_required">
                Signoff Required
                </vs-checkbox>
            </div>
            </div>
        </div>
          

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const DepartmentsRepository = RepositoryFactory.get('departments');
  const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        description: '',
        signoff_required: true,
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'CreateTemplate',
    data() {
      return initialState()
    },
    async mounted() {
    },
    components: {
    'v-select': vSelect,
    },
    methods: {
      async openPopup(data) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!data) {
            this.id = data.id
            this.form = data
            this.isCreateMode = false
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchTemplateDetails() {
        await this.$vs.loading({
          container: '#create-template-popup',
          scale: 0.45
        })
        try {
          const {data} = (await ScheduledTasksRepository.getTemplate(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-template-popup > .con-vs-loading')
      },
      async onClickCreateTemplate() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-template-popup',
          scale: 0.45
        })
        try {
          const {data} = await ScheduledTasksRepository.createTemplate(this.form);
          this.showSuccessMessage('Template added successfully');
          this.$router.push({path: `/pages/settings/templates/${data.data.id}`})
        } catch (e) {
          this.$vs.loading.close('#create-template-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-template-popup > .con-vs-loading')
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
